import MoreOptionsMenu from '@sdk/components/ui/MoreOptionsMenu';
import ToastComponent from '@sdk/common/toast/ToastComponent';

import { ConversationDeleteModal } from '@web/conversations/Conversation/ConversationDeleteModal/ConversationDeleteModal';
import { LeaveConversationModal } from '@web/conversations/Conversation/LeaveConversationModal/LeaveConversationModal';
import { ArchiveConversationModal } from '@web/conversations/Conversation/ArchiveConversationModal/ArchiveConversationModal';
import { ExportConversationModal } from '@web/conversations/Conversation/ExportConversationModal/ExportConversationModal';
import { useConversationHeaderActions } from '@web/conversations/Conversation/ConversationHeaderActions/conversationHeaderActions.hooks';
import { ACTION_TOAST_ID } from '@web/conversations/Conversation/ConversationHeaderActions/conversationHeaderActions.consts';

export const ConversationHeaderActions = () => {
  const {
    archiveConversationModalState,
    deleteConversationModalState,
    leaveConversationModalState,
    exportConversationModalState,
    menuOptions,
    onClick,
  } = useConversationHeaderActions();

  return (
    <>
      <MoreOptionsMenu options={menuOptions} onClick={onClick} noBorder buttonWidth={120} />
      <ExportConversationModal modalState={exportConversationModalState} />
      <ArchiveConversationModal modalState={archiveConversationModalState} />
      <ConversationDeleteModal modalState={deleteConversationModalState} />
      <LeaveConversationModal modalState={leaveConversationModalState} />
      <ToastComponent containerId={ACTION_TOAST_ID} />
    </>
  );
};
